import Vue from 'vue';
import './plugins/vuetify';
import firebase from 'firebase';
import VueMoment from 'vue-moment';
import VueHead from 'vue-head';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';

Vue.config.productionTip = false;

const config = {
  apiKey: 'AIzaSyBoz5P8sEWZ9pO3_oxvhwyhfVKqGK4XN-A',
  authDomain: 'lollspace.firebaseapp.com',
  databaseURL: 'https://lollspace.firebaseio.com',
  projectId: 'lollspace',
  storageBucket: 'lollspace.appspot.com',
  messagingSenderId: '706091815127',
};
firebase.initializeApp(config);

// Setting Cloud Firestore
// const firestore = firebase.firestore();
// const settings = { timestampsInSnapshots: true };
// firestore.settings();

Vue.use(VueMoment);
Vue.use(VueHead, {
  separator: '|',
  complement: 'LollSpace',
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
